// extracted by mini-css-extract-plugin
export default {"bar":"styles_bar__uO4Wz","info":"styles_info__82YX5","title":"styles_title__UcoFm","counter":"styles_counter__nqyvy"};